module.exports = __webpack_public_path__ + "themify.e23a7dcaefbde4e74e26.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/icons/themify-icons/fonts/themify.ttf
// module id = ./src/assets/styles/icons/themify-icons/fonts/themify.ttf
// module chunks = styles